import Colors from '@/constants/Colors';
import { Result } from 'antd';
import { StyledCard } from './Result.styled';

const CustomResult = ({ children, ...props }) => {
  const { status } = props;

  return (
    <StyledCard className={status}>
      <Result {...props}>{children}</Result>
    </StyledCard>
  );
};

export default CustomResult;
